/**
 * Coups de pouce, Attendus 1236 « dans un repère orthogonal, lire les
 * coordonnées d'un point donné » et 1237 « placer un point de coordonnées
 * données » (3e, Repérage ; un fichier gen_1236 à deux jeux de clés).
 * Seconde passe 3e (2026-09-13). UNE page STATIQUE partagée par les deux
 * attendus : le même geste dans les deux sens.
 *
 * L'image que l'élève a déjà : le repère de 5e et 4e avec le chemin depuis
 * l'origine, « d'abord je marche (horizontal), ensuite je monte ou je
 * descends (vertical) ». Le point D(2 ; −3) : 2 vers la droite en bleu,
 * 3 vers le bas en orange ; la première coordonnée est celle de la marche,
 * la deuxième celle de la montée ou de la descente (contre l'inversion
 * (−3 ; 2)) ; « la montée ensuite » seul contredisait le « je descends » de
 * la ligne du dessus (revue prof 2026-09-18).
 *
 * SACRIFIÉ : (2 ; −3) (gen_1236.SACRIFIE), exclu des deux gens
 * (gen1236-1237.self.test.js).
 */
import { svg } from './1054';

const ORANGE = '#EA580C';
const BLEU = '#2563EB';
const ENCRE = '#1E293B';
const GRIS = '#64748B';

const ligne = (y, contenu, taille = 12, couleur = ENCRE) => `<text x="200" y="${y}" font-size="${taille}" text-anchor="middle" fill="${couleur}">${contenu}</text>`;

// Le repère : origine en (150, 110), 26 px par unité, x de −3 à 4, y de −4 à 3.
const OX = 150; const OY = 110; const U = 26;
const X = (x) => OX + x * U; const Y = (y) => OY - y * U;
const GRILLE = [
    ...Array.from({ length: 8 }, (_, k) => k - 3).map((x) => `<line x1="${X(x)}" y1="${Y(3)}" x2="${X(x)}" y2="${Y(-4)}" stroke="#E2E8F0" stroke-width="1"/>`),
    ...Array.from({ length: 8 }, (_, k) => k - 4).map((y) => `<line x1="${X(-3)}" y1="${Y(y)}" x2="${X(4)}" y2="${Y(y)}" stroke="#E2E8F0" stroke-width="1"/>`),
].join('\n  ');
const AXES = `<line x1="${X(-3) - 8}" y1="${OY}" x2="${X(4) + 12}" y2="${OY}" stroke="${ENCRE}" stroke-width="1.4"/>
  <polygon points="${X(4) + 12},${OY} ${X(4) + 4},${OY - 4} ${X(4) + 4},${OY + 4}" fill="${ENCRE}"/>
  <line x1="${OX}" y1="${Y(-4) + 8}" x2="${OX}" y2="${Y(3) - 12}" stroke="${ENCRE}" stroke-width="1.4"/>
  <polygon points="${OX},${Y(3) - 12} ${OX - 4},${Y(3) - 4} ${OX + 4},${Y(3) - 4}" fill="${ENCRE}"/>
  <text x="${OX - 8}" y="${OY + 14}" font-size="11" text-anchor="end" fill="${ENCRE}">O</text>
  ${[1, 2, 3, 4].map((x) => `<text x="${X(x)}" y="${OY + 14}" font-size="10" text-anchor="middle" fill="${GRIS}">${x}</text>`).join('')}
  ${[-1, -2, -3, -4].map((y) => `<text x="${OX - 6}" y="${Y(y) + 4}" font-size="10" text-anchor="end" fill="${GRIS}">${y}</text>`).join('')}`;

const CHEMIN = `<line x1="${OX}" y1="${OY}" x2="${X(2)}" y2="${OY}" stroke="${BLEU}" stroke-width="3"/>
  <text x="${OX + 6}" y="${OY - 8}" font-size="12" font-weight="bold" text-anchor="start" fill="${BLEU}">2 à droite</text>
  <line x1="${X(2)}" y1="${OY}" x2="${X(2)}" y2="${Y(-3)}" stroke="${ORANGE}" stroke-width="3"/>
  <text x="${X(2) + 8}" y="${Y(-1.5) + 4}" font-size="12" font-weight="bold" text-anchor="start" fill="${ORANGE}">3 en bas</text>
  <circle cx="${X(2)}" cy="${Y(-3)}" r="4" fill="${ENCRE}"/>
  <text x="${X(2) + 8}" y="${Y(-3) + 14}" font-size="13" font-weight="bold" text-anchor="start" fill="${ENCRE}">D(<tspan fill="${BLEU}">2</tspan> ; <tspan fill="${ORANGE}">−3</tspan>)</text>`;

const SVG = svg(
    'Un repère orthogonal, origine O. Depuis O, je marche 2 vers la droite, en bleu, puis je descends de 3, en orange : j’arrive au point D. D a pour coordonnées 2 point-virgule moins 3. D’abord je marche, ensuite je monte ou je descends. Le premier nombre est la marche, le deuxième la montée ou la descente.',
    `${GRILLE}
  ${AXES}
  ${CHEMIN}
  ${ligne(246, `D’abord je <tspan fill="${BLEU}" font-weight="bold">marche</tspan> (2 à droite), ensuite je <tspan fill="${ORANGE}" font-weight="bold">descends</tspan> (3).`, 13)}
  ${ligne(268, `D(<tspan fill="${BLEU}" font-weight="bold">2</tspan> ; <tspan fill="${ORANGE}" font-weight="bold">−3</tspan>) : la marche d’abord, la montée ou la descente ensuite.`, 12)}
  ${ligne(290, 'Vers la gauche ou vers le bas, c’est un nombre négatif.', 12, GRIS)}`,
    306,
);

const AIDE = { pages: [{ titre: 'D’abord je marche, ensuite je monte', svg: SVG }] };

const CP_1236 = {
    lire_texte_trou_saisie: AIDE,
    lire_qcm_unique: AIDE,
};
/** 1237 : les clés placer_* de gen_1236, servies par gen_1237. */
export const CP_1237 = {
    placer_placer_points_2d: AIDE,
    croix_qcm_unique: AIDE,
};

export default CP_1236;
